import useLocalStorage from './useLocalStorage';

const useDeviceId = () => {
  const [storeDeviceId, retrieveDeviceId, removeDeviceId] =
    useLocalStorage<string>('__Device_Id__');
  return { storeDeviceId, retrieveDeviceId, removeDeviceId };
};

export default useDeviceId;
